"use client"

import { useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import Step1 from "./step1"
import Step2 from "./step2"
import Step3 from "./step3"
import { UserAuth } from "../../context/AuthContext"
import Loading from "../../components/Loading"
import { useTranslations } from "../../translations"

const RegisterPage = () => {
  const { step } = useParams()
  const [state, setState] = useState({})
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const navigate = useNavigate()
  const { createUser, user, percent, loading } = UserAuth()
  const { t } = useTranslations()

  const register = async (data) => {
    try {
      await createUser(data)
      return {}
    } catch (error) {
      switch (error.code) {
        case "auth/email-already-in-use":
          return {
            error: t("emailInUse"),
          }
        case "auth/invalid-email":
          return {
            error: t("invalidEmail"),
          }
        case "auth/weak-password":
          return {
            error: t("weakPassword"),
          }
        case "auth/too-many-requests":
          return {
            error: t("tooManyRequests"),
          }
        default:
          return {
            error: t("checkConnection"),
          }
      }
    }
  }

  const onSubmit = (data, step) => {
    setState({ ...state, ...data })
    if (step === "step1") {
      navigate("/register/step2")
    }

    if (step === "step2") {
      navigate("/register/step3")
    }

    if (step === "step3") {
      /* window.alert('Finished'); */

      register(data)
    }
  }
  if (loading) {
    return <Loading />
  }

  const getProgress = () => {
    switch (step) {
      case "step1": return "33%";
      case "step2": return "66%";
      case "step3": return "100%";
      default: return "0%";
    }
  }

  const renderStep = () => {
    switch (step) {
      case "step1":
        return <Step1 step={step} defaultValues={state} next={onSubmit} />
      case "step2":
        return <Step2 step={step} defaultValues={state} next={onSubmit} />
      case "step3":
        return <Step3 step={step} defaultValues={state} next={onSubmit} />
      default:
        return <Loading />
    }
  }

  return (
    <div className="login-content">
      <div className="auth-progress-container">
        <div className="auth-progress-bar" style={{ width: getProgress() }}></div>
      </div>
      {renderStep()}
    </div>
  )
}

export default RegisterPage
